var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "configurar-Servipag" },
    [
      _c(
        "FormFieldsContainer",
        [
          _c(
            "v-flex",
            { attrs: { sm2: "", md2: "" } },
            [
              _c("DatePicker", {
                attrs: {
                  label: _vm.formFields.fechaInicio.label,
                  "error-messages": _vm.errors.collect(
                    _vm.formFields.fechaInicio.id
                  ),
                  id: _vm.formFields.fechaInicio.id
                },
                model: {
                  value: _vm.formFields.fechaInicio.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.fechaInicio, "value", $$v)
                  },
                  expression: "formFields.fechaInicio.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm2: "", md2: "" } },
            [
              _c("DatePicker", {
                attrs: {
                  label: _vm.formFields.fechaFinal.label,
                  "error-messages": _vm.errors.collect(
                    _vm.formFields.fechaFinal.id
                  ),
                  id: _vm.formFields.fechaFinal.id
                },
                model: {
                  value: _vm.formFields.fechaFinal.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.fechaFinal, "value", $$v)
                  },
                  expression: "formFields.fechaFinal.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm2: "", md2: "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: _vm.formFields.folio.label,
                  type: "number",
                  required: ""
                },
                model: {
                  value: _vm.formFields.folio.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.folio, "value", $$v)
                  },
                  expression: "formFields.folio.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm2: "", md2: "" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: _vm.formFields.Estado.label,
                  items: _vm.estadoLista,
                  "item-text": "estado",
                  "item-value": "estado"
                },
                model: {
                  value: _vm.formFields.Estado.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.Estado, "value", $$v)
                  },
                  expression: "formFields.Estado.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm1: "", md1: "" } },
            [
              _c(
                "v-btn",
                { on: { click: _vm.handleBuscarClick } },
                [_c("v-icon", [_vm._v("search")]), _vm._v("Filtrar\n      ")],
                1
              )
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { sm1: "", md1: "" } },
            [
              _c(
                "v-btn",
                { on: { click: _vm.clearFilters } },
                [_c("v-icon", [_vm._v("clear")]), _vm._v("Limpiar ")],
                1
              )
            ],
            1
          ),
          _c("v-flex", { attrs: { sm1: "", md1: "" } }, [
            _c(
              "div",
              { attrs: { aling: "right" } },
              [
                _c(
                  "v-btn",
                  {
                    attrs: { flat: "", small: "", color: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.exportFile()
                      }
                    }
                  },
                  [
                    _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                      _vm._v("cloud_download")
                    ]),
                    _vm._v("  \n          "),
                    _c("span", { staticClass: "importExportBtnTexto" }, [
                      _vm._v("Exportar CSV")
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c(
            "v-flex",
            { attrs: { sm12: "", md12: "", ridcard: "", "rounded-card": "" } },
            [
              _c("MantenedorGrid", {
                attrs: {
                  "grid-options": _vm.gridOptions,
                  "funcionalidad-id": _vm.funcionalidad
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }